import { useEffect, useState } from "react";
import { FolderOpen, Music2 } from "lucide-react";
import { toast } from "sonner";
import { api, API, errMsg, fmtDate } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

const Thumb = ({ u }) => {
  const [err, setErr] = useState(false);
  if (u.kind === "audio") return <div className="w-12 h-12 rounded bg-slate-800 flex items-center justify-center shrink-0"><Music2 size={16} className="text-amber-300" /></div>;
  return <div className="w-12 h-12 rounded bg-slate-800 overflow-hidden shrink-0">{!err && <img src={`${API}/uploads/${u.id}/thumb`} alt="" loading="lazy" onError={() => setErr(true)} className="w-full h-full object-cover" />}</div>;
};

export const UploadPicker = ({ kind, onPick, label = "From my uploads", testId, disabled, className = "" }) => {
  const [open, setOpen] = useState(false);
  const [list, setList] = useState(null);
  const [busy, setBusy] = useState("");
  useEffect(() => {
    if (!open) return;
    setList(null);
    api.get(`/my-uploads?kind=${kind === "image" ? "artwork&images_only=true" : kind}`).then((r) => setList(r.data)).catch((e) => { toast.error(errMsg(e)); setList([]); });
  }, [open, kind]);
  const pick = async (u) => { setBusy(u.id); try { await onPick(u); setOpen(false); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(""); } };
  return (
    <>
      <button type="button" disabled={disabled} onClick={() => setOpen(true)} data-testid={testId}
        className={`inline-flex items-center gap-1 text-xs border border-slate-700 rounded-md px-2 h-8 hover:border-amber-500/50 disabled:opacity-50 ${className}`}><FolderOpen size={12} />{label}</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg bg-slate-950 border-amber-500/30" data-testid="upload-picker-dialog">
          <DialogHeader><DialogTitle className="font-display">Choose from your uploads</DialogTitle></DialogHeader>
          <p className="text-xs text-slate-400 -mt-2">Files you've uploaded to any of your books. Add more on a book's Upload tab.</p>
          <div className="max-h-[55vh] overflow-y-auto divide-y divide-slate-800 scrollbar-thin" data-testid="upload-picker-list">
            {list === null && <p className="text-sm text-slate-500 py-6 text-center">Loading…</p>}
            {list?.length === 0 && <p className="text-sm text-slate-500 py-6 text-center" data-testid="upload-picker-empty">No {kind === "audio" ? "audio files" : "images"} uploaded yet.</p>}
            {list?.map((u) => (
              <button key={u.id} type="button" onClick={() => pick(u)} disabled={!!busy} data-testid={`upload-picker-item-${u.id}`}
                className="w-full flex items-center gap-3 py-2.5 px-1 text-left hover:bg-amber-500/5 transition-colors disabled:opacity-50">
                <Thumb u={u} />
                <div className="min-w-0 flex-1"><p className="text-sm text-slate-100 truncate">{u.filename}</p><p className="text-[11px] text-slate-500 truncate">{u.book_title} · {fmtDate(u.created_at)}</p></div>
                <span className="text-xs text-amber-300">{busy === u.id ? "Adding…" : "Use"}</span>
              </button>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
